// eslint-disable-next-line import/prefer-default-export
export const TOGGLE_DISTRACTION_FREE_MODE = 'UI/TOGGLE_DISTRACTION_FREE_MODE';
